import { Auth } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Routes from './routes';
import './index.css';
import ExitIntentFeedback from './components/ExitIntentFeedback.js';
import GoogleTagManager from './components/GoogleTagManager';

function App({ signOut }) {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const [isReloading, setIsReloading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const CURRENT_APP_VERSION = process.env.REACT_APP_VERSION;

  // ============================
  //   🧩 COGNITO SESSION CHECK
  // ============================
  useEffect(() => {
    Auth.currentSession()
      .then((session) => {
        if (session.isValid()) {
          setIsLoggedIn(true);
          console.log('✅ User is logged in');
        } else {
          console.log('❌ Invalid session - signing out');
          signOut();
        }
      })
      .catch(() => {
        // Anonymous user - allowed
        setIsLoggedIn(false);
        console.log('👤 Anonymous user detected');
      });
  }, [signOut]);

  // ============================
  //   🚀 VERSION CONTROL LOGIC
  // ============================

    // function checkAllNullExceptPersist(obj) {
    //   return Object.keys(obj).every(key => {
    //     if (key === '_persist') {
    //       return true; // Skip _persist from the check
    //     }
    //     try {
    //       const parsed = JSON.parse(obj[key]);
    //       return Object.values(parsed).every(value => value === null);
    //     } catch {
    //       return obj[key] === null;
    //     }
    //   });
    // }

  // useEffect(async() => {
  //   const res = await fetch('/meta.json?_=' + Date.now(), { cache: 'no-store' });
  //       const meta = await res.json();
  //   // Skip version check if update just finished
  //   if (localStorage.getItem('appUpdateInProgress') === 'true') {
  //     console.log('✅ Update completed. Resetting flag.');
  //     localStorage.removeItem('appUpdateInProgress');
  //     return;
  //   }

  //   async function checkAppVersion() {
  //     console.log('localeee',JSON.parse(localStorage.getItem('persist:root')))
  //     try {
  //       if(checkAllNullExceptPersist(JSON.parse(localStorage.getItem('persist:root')))){
  //         console.log('localeee',localStorage.getItem('persist:root'))
  //         localStorage.setItem('appVersion', meta.version);
  //         return null
  //       }
  //       else{
        
  //       const storedVersion = localStorage.getItem('appVersion');

  //       console.log('🔍 Checking versions:');
  //       console.log(' - Current build:', CURRENT_APP_VERSION);
  //       console.log(' - Meta version:', meta.version);
  //       console.log(' - Stored version:', storedVersion);

  //       // 🔒 Prevent false triggers: if app already matches meta, skip popup
  //       if (meta.version === CURRENT_APP_VERSION || meta.version === storedVersion) {
  //         console.log('✅ Already up to date');
  //         localStorage.setItem('appVersion', meta.version);
  //         return;
  //       }

  //       // 🚨 New version found
  //       console.log('🆕 New version detected:', meta.version);
  //       setNewVersionAvailable(true);
  //     }
  //     } catch (err) {
  //       console.warn('⚠ Version check failed:', err);
  //     }
  //   }

  //   // Delay 1s to ensure new meta.json loads properly after update
  //   const timeout = setTimeout(() => {
  //     checkAppVersion();
  //     const interval = setInterval(checkAppVersion, 5 * 60 * 1000);
  //     return () => clearInterval(interval);
  //   }, 1000);

  //   return () => clearTimeout(timeout);
  // }, [CURRENT_APP_VERSION]);

  // ============================
  //   🔄 HANDLE FORCE UPDATE
  // ============================
  // const handleForceUpdate = async () => {
  //   if (isReloading) return;
  //   setIsReloading(true);

  //   try {
  //     console.log('🔄 Starting update process...');
  //     console.log('👤 User type:', isLoggedIn ? 'Logged In' : 'Anonymous');

  //     // ============================
  //     // STEP 1: PRESERVE DATA BASED ON USER TYPE
  //     // ============================
  //     let cartData = null;
  //     let addressData = null;
  //     let persistRootBackup = null;

  //     try {
  //       const persistRoot = localStorage.getItem('persist:root');
        
  //       if (persistRoot) {
  //         const parsed = JSON.parse(persistRoot);
  //         console.log('Found persist:root data',parsed);
  //         delete parsed.auth
          
  //         if (isLoggedIn) {
  //           // ============================
  //           // LOGGED-IN USER: Preserve everything in persist:root
  //           // ============================
  //           persistRootBackup = JSON.stringify(parsed);
  //           console.log('🔐 Logged-in user: Preserving entire persist:root (auth + cart + address)');
  //         } else {
  //           // ============================
  //           // ANONYMOUS USER: Preserve only cart and address
  //           // ============================
  //           if (parsed.cart) {
  //             cartData = parsed.cart;
  //             console.log('🛒 Anonymous user: Cart data preserved');
  //           }
            
  //           if (parsed.deliveryAddress || parsed.address) {
  //             addressData = parsed.deliveryAddress || parsed.address;
  //             console.log('📍 Anonymous user: Address data preserved');
  //           }
            
  //           if (cartData || addressData) {
  //             console.log('✅ Anonymous user: Cart and address will be restored after update');
  //           }
  //         }
  //       } else {
  //         console.log('⚠ No persist:root found in localStorage');
  //       }
  //     } catch (err) {
  //       console.warn('⚠ Failed to extract persist:root data:', err);
  //     }

  //     // ============================
  //     // STEP 2: MARK UPDATE AS IN PROGRESS
  //     // ============================
  //     localStorage.setItem('appUpdateInProgress', 'true');

  //     // ============================
  //     // STEP 3: CLEAR STORAGE (EXCEPT COGNITO KEYS)
  //     // ============================
  //     console.log('🧹 Cleaning up old storage...');
      
  //     // 1️⃣ Clear all localStorage except Cognito keys
  //     Object.keys(localStorage).forEach((key) => {
  //       if (
  //         !key.includes('CognitoIdentityServiceProvider') &&
  //         !key.includes('amplify-authenticator-cache') &&
  //         !key.includes('aws.cognito.identity') &&
  //         !key.includes('amplify-signin-with-hostedUI') &&
  //         key !== 'appUpdateInProgress'
  //       ) {
  //         localStorage.removeItem(key);
  //         console.log('  ❌ Removed:', key);
  //       }
  //     });

  //     // 2️⃣ Clear sessionStorage
  //     sessionStorage.clear();
  //     console.log('✅ SessionStorage cleared');

  //     // 3️⃣ Clear cache storage
  //     if ('caches' in window) {
  //       const cacheNames = await caches.keys();
  //       await Promise.all(cacheNames.map((name) => caches.delete(name)));
  //       console.log('✅ Browser caches cleared:', cacheNames.length);
  //     }

  //     // 4️⃣ Unregister old service workers
  //     if ('serviceWorker' in navigator) {
  //       const registrations = await navigator.serviceWorker.getRegistrations();
  //       for (const registration of registrations) {
  //         await registration.unregister();
  //       }
  //       console.log('✅ Service workers unregistered:', registrations.length);
  //     }

  //     // ============================
  //     // STEP 4: FETCH AND SET NEW VERSION
  //     // ============================
  //     try {
  //       const res = await fetch('/meta.json?_=' + Date.now(), { cache: 'no-store' });
  //       const meta = await res.json();
  //       localStorage.setItem('appVersion', meta.version);
  //       console.log('✅ New version set:', meta.version);
  //     } catch (err) {
  //       console.warn('⚠ Could not update meta version locally');
  //       localStorage.setItem('appVersion', CURRENT_APP_VERSION);
  //     }

  //     // ============================
  //     // STEP 5: RESTORE DATA BASED ON USER TYPE
  //     // ============================
  //     if (isLoggedIn && persistRootBackup) {
  //       // Restore everything for logged-in users
  //       localStorage.setItem('persist:root', persistRootBackup);
  //       console.log('✅ Logged-in user: persist:root fully restored');
  //     } else if (!isLoggedIn && (cartData || addressData)) {
  //       // Restore only cart and address for anonymous users
  //       const newPersistRoot = {
  //         _persist: '{"version":-1,"rehydrated":true}'
  //       };
        
  //       if (cartData) {
  //         newPersistRoot.cart = cartData;
  //         console.log('✅ Anonymous user: Cart data restored');
  //       }
        
  //       if (addressData) {
  //         newPersistRoot.deliveryAddress = addressData;
  //         console.log('✅ Anonymous user: Address data restored');
  //       }
        
  //       localStorage.setItem('persist:root', JSON.stringify(newPersistRoot));
  //       console.log('✅ Anonymous user: persist:root created with cart and address');
  //     } else {
  //       console.log('ℹ No data to restore');
  //     }

  //     // ============================
  //     // STEP 6: RELOAD APP
  //     // ============================
  //     console.log('🔄 Reloading application...');
      
  //     // Small delay to ensure all operations complete
  //     await new Promise(resolve => setTimeout(resolve, 100));
      
  //     // Reload app with cache-busting
  //     window.location.href = window.location.origin + '?_=' + Date.now();
      
  //   } catch (err) {
  //     console.error('❌ Error during update:', err);
  //     window.location.reload(true);
  //   }
  // };

  return (
    <>
      <GoogleTagManager gtmId="GTM-ND8NLQD6" />
      <Routes />
       <ExitIntentFeedback />

      <ToastContainer />

      {/* {newVersionAvailable && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            backdropFilter: 'blur(5px)',
            color: '#fff',
            zIndex: 99999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            padding: '20px',
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }}
        >
          <div style={{ maxWidth: 500 }}>
            <h2 style={{ fontSize: 28, marginBottom: 16, fontWeight: 600 }}>
              🚀 New Version Available
            </h2>
            
            <p style={{ fontSize: 16, lineHeight: 1.5, marginBottom: 24, opacity: 0.9 }}>
              A new version of 1800Spirits is ready!
              {isLoggedIn && (
                <><br /><small style={{ opacity: 0.7 }}>
                  You'll be logged out for security reasons.
                </small></>
              )}
              {!isLoggedIn && (
                <><br /><small style={{ opacity: 0.7 }}>
                  Your cart and address will be preserved.
                </small></>
              )}
            </p>

            <button
              onClick={handleForceUpdate}
              disabled={isReloading}
              style={{
                backgroundColor: isReloading ? '#666' : '#B72618',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '14px 32px',
                fontSize: 16,
                fontWeight: 600,
                cursor: isReloading ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s',
                opacity: isReloading ? 0.7 : 1
              }}
              onMouseEnter={(e) => {
                if (!isReloading) e.target.style.backgroundColor = '#a01f14';
              }}
              onMouseLeave={(e) => {
                if (!isReloading) e.target.style.backgroundColor = '#B72618';
              }}
            >
              {isReloading ? '🔄 Updating...' : '✨ Update Now'}
            </button>

            {isReloading && (
              <p style={{ marginTop: 16, fontSize: 14, opacity: 0.7 }}>
                Please wait, this may take a moment...
              </p>
            )}
          </div>
        </div>
      )} */}
    </>
  );
}

const stateMapper = (state) => ({});
const dispatchMapper = (dispatch) => ({
  signOut: dispatch.auth.signOut,
});

export default connect(stateMapper, dispatchMapper)(App);